const x = [
  {
    index: 0,
    id: 0,
    type: "Feature",
    properties: {
      Nummer: 2023,
      Standort: "Opernhaus - Parkplatz West",
      Bezirk: "W-Barmen",
      Anzahl: 105,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: "2,00 €",
      info: {
        title: "Opernhaus - Parkplatz West",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "105 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [373876.519697561, 5681046.66445972],
    },
    text: 2023,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2144,
      Standort: "Hochstaße 97",
      Bezirk: "W-Elberfeld",
      Anzahl: 11,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Hochstaße 97",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "11 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370499.742571454, 5680441.54200493],
    },
    text: 2144,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2171,
      Standort: "Luisenstraße - Ecke Bergstr.",
      Bezirk: "W-Elberfeld",
      Anzahl: 6,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Luisenstraße - Ecke Bergstr.",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "6 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370289.365502467, 5680130.93266922],
    },
    text: 2171,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2175,
      Standort: "Luisenstraße - Deweerthscher Garten",
      Bezirk: "W-Elberfeld",
      Anzahl: 15,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Luisenstraße - Deweerthscher Garten",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "15 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [369727.25557661, 5679784.85975938],
    },
    text: 2175,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2101,
      Standort: "Kasinostraße - Kreisel",
      Bezirk: "W-Elberfeld",
      Anzahl: 3,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Kasinostraße - Kreisel",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "3 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370353.94049209, 5679978.97298158],
    },
    text: 2101,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2102,
      Standort: "Aue gegenüber 86",
      Bezirk: "W-Elberfeld",
      Anzahl: 47,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Aue gegenüber 86",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "47 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [369867.313000001, 5679680.893],
    },
    text: 2102,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2034,
      Standort: "Kleiner Werth gegenüber 10",
      Bezirk: "W-Barmen",
      Anzahl: 18,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Kleiner Werth gegenüber 10",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "18 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374787.758921326, 5681736.56740513],
    },
    text: 2034,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2140,
      Standort: "Schloßbleiche - Bankstraße",
      Bezirk: "W-Elberfeld",
      Anzahl: 10,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Schloßbleiche - Bankstraße",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "10 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370527.019000001, 5679919.356],
    },
    text: 2140,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2148,
      Standort: "Am Kolk - Post",
      Bezirk: "W-Elberfeld",
      Anzahl: 51,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Am Kolk - Post",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "51 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370849.287794173, 5680107.17809855],
    },
    text: 2148,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2111,
      Standort: "Südstr - Schule",
      Bezirk: "W-Elberfeld",
      Anzahl: 20,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: null,
      info: {
        title: "Südstr - Schule",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "20 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370475.098351638, 5679747.1353738],
    },
    text: 2111,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2031,
      Standort: "Parkplatz Engelsstraße - B7",
      Bezirk: "W-Barmen",
      Anzahl: 7,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: "2,00 €",
      info: {
        title: "Parkplatz Engelsstraße - B7",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "7 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [373761.262728201, 5681046.69973757],
    },
    text: 2031,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2062,
      Standort: "Winklerstraße - Fischertal",
      Bezirk: "W-Barmen",
      Anzahl: 12,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Winklerstraße - Fischertal",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "12 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374243.60762032, 5681255.11401152],
    },
    text: 2062,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2045,
      Standort: "Höhne - Rudolf-Herzog-Straße",
      Bezirk: "W-Barmen",
      Anzahl: 13,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Höhne - Rudolf-Herzog-Straße",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "13 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374830.144285952, 5681581.41860314],
    },
    text: 2045,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2114,
      Standort: "Aue - Parkplatz",
      Bezirk: "W-Elberfeld",
      Anzahl: 38,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Aue - Parkplatz",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "38 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370246.030272456, 5679799.21627085],
    },
    text: 2114,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2113,
      Standort: "Luisenstraße gegenüber 11",
      Bezirk: "W-Elberfeld",
      Anzahl: 7,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Luisenstraße gegenüber 11",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "7 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370451.840986064, 5680207.50481235],
    },
    text: 2113,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2174,
      Standort: "Johannisberg - Parkpalette 2",
      Bezirk: "W-Elberfeld",
      Anzahl: 36,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: null,
      info: {
        title: "Johannisberg - Parkpalette 2",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "36 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370479.370000001, 5679617.104],
    },
    text: 2174,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2026,
      Standort: "Bahnhof Barmen WEST",
      Bezirk: "W-Barmen",
      Anzahl: 57,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: "2,00 €",
      info: {
        title: "Bahnhof Barmen WEST",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "57 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374120.536083901, 5681140.52856152],
    },
    text: 2026,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2039,
      Standort: "Höhne 82",
      Bezirk: "W-Barmen",
      Anzahl: 5,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Höhne 82",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "5 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374790.055376955, 5681530.7962137],
    },
    text: 2039,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2024,
      Standort: "Stresemannstraße - Winklerstraße",
      Bezirk: "W-Barmen",
      Anzahl: 20,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Stresemannstraße - Winklerstraße",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "20 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374190.571785082, 5681232.77554879],
    },
    text: 2024,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2038,
      Standort: "Stresemannstraße -  B7",
      Bezirk: "W-Barmen",
      Anzahl: 29,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Stresemannstraße -  B7",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "29 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374163.012729964, 5681293.60390794],
    },
    text: 2038,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2115,
      Standort: "Aue gegenüber 80",
      Bezirk: "W-Elberfeld",
      Anzahl: 47,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Aue gegenüber 80",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "47 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [369914.089409571, 5679692.10079572],
    },
    text: 2115,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2128,
      Standort: "Bundesallee 241",
      Bezirk: "W-Elberfeld",
      Anzahl: 12,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: null,
      info: {
        title: "Bundesallee 241",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "12 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [371250.958000001, 5679950.39],
    },
    text: 2128,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2055,
      Standort: "Westkotterstraße 9",
      Bezirk: "W-Barmen",
      Anzahl: 9,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Westkotterstraße 9",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "9 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374662.651379012, 5681914.78648674],
    },
    text: 2055,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2013,
      Standort: "Bleicherstraße gegenüber 22 (West)",
      Bezirk: "W-Barmen",
      Anzahl: 7,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Bleicherstraße gegenüber 22 (West)",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "7 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374033.264172428, 5681471.65886695],
    },
    text: 2013,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2029,
      Standort: "Am Clef",
      Bezirk: "W-Barmen",
      Anzahl: 14,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Am Clef",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "14 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374582.488540342, 5681380.14196419],
    },
    text: 2029,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2040,
      Standort: "Paul-Humburg-Straße - Heubruch",
      Bezirk: "W-Barmen",
      Anzahl: 7,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Paul-Humburg-Straße - Heubruch",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "7 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374298.122289778, 5681629.18967111],
    },
    text: 2040,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2133,
      Standort: "Dessauerstraße",
      Bezirk: "W-Elberfeld",
      Anzahl: 15,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Dessauerstraße",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "15 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [371173.997000001, 5679803.319],
    },
    text: 2133,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2043,
      Standort: "Wegnerstraße - West",
      Bezirk: "W-Barmen",
      Anzahl: 9,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Wegnerstraße - West",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "9 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374543.571831006, 5681631.56492693],
    },
    text: 2043,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2002,
      Standort: "Diedenhofer Straße - Parkplatz B7",
      Bezirk: "W-Barmen",
      Anzahl: 19,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Diedenhofer Straße - Parkplatz B7",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "19 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374703.175999999, 5681494.006],
    },
    text: 2002,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2011,
      Standort: "Mühlenweg 17",
      Bezirk: "W-Barmen",
      Anzahl: 5,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Mühlenweg 17",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "5 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374449.743633229, 5681769.8274267],
    },
    text: 2011,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2124,
      Standort: "Friedrich-Ebert-Straße 59",
      Bezirk: "W-Elberfeld",
      Anzahl: 12,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Friedrich-Ebert-Straße 59",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "12 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [369960.870223945, 5679821.57755846],
    },
    text: 2124,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2061,
      Standort: "Höhne 63",
      Bezirk: "W-Barmen",
      Anzahl: 10,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: "4,00 €",
      Abendtarif: null,
      info: {
        title: "Höhne 63",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "10 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374604.91, 5681488.288],
    },
    text: 2061,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2035,
      Standort: "Bachstraße 17",
      Bezirk: "W-Barmen",
      Anzahl: 10,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Bachstraße 17",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "10 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374755.57633799, 5681814.48817027],
    },
    text: 2035,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2012,
      Standort: "Steinweg  - Bleicherstraße",
      Bezirk: "W-Barmen",
      Anzahl: 8,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Steinweg  - Bleicherstraße",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "8 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374097.814212293, 5681536.30984556],
    },
    text: 2012,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2018,
      Standort: "Zwinglistraße - Gemarker Str.",
      Bezirk: "W-Barmen",
      Anzahl: 32,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Zwinglistraße - Gemarker Str.",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "32 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374305.242845206, 5681533.02782607],
    },
    text: 2018,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2020,
      Standort: "Zwinglistraße - Pannewiese",
      Bezirk: "W-Barmen",
      Anzahl: 0,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Zwinglistraße - Pannewiese",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "0 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374354.42168631, 5681562.17357751],
    },
    text: 2020,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2010,
      Standort: "Bernhard-Letterhaus-Straße 3",
      Bezirk: "W-Barmen",
      Anzahl: 25,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Bernhard-Letterhaus-Straße 3",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "25 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374106.022750238, 5681396.53116113],
    },
    text: 2010,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2141,
      Standort: "Alexanderstraße",
      Bezirk: "W-Elberfeld",
      Anzahl: 7,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Alexanderstraße",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "7 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370461.647, 5679838.691],
    },
    text: 2141,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2142,
      Standort: "Kosice-Ufer 1",
      Bezirk: "W-Elberfeld",
      Anzahl: 30,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Kosice-Ufer 1",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "30 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [371353.579, 5679795.705],
    },
    text: 2142,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2032,
      Standort: "Steinweg - Viktorstraße",
      Bezirk: "W-Barmen",
      Anzahl: 9,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Steinweg - Viktorstraße",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "9 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374083.993894721, 5681599.99479541],
    },
    text: 2032,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2134,
      Standort: "Kipdorf 58",
      Bezirk: "W-Elberfeld",
      Anzahl: 3,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Kipdorf 58",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "3 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [371061.866430727, 5680197.57063956],
    },
    text: 2134,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2127,
      Standort: "Döppersberg",
      Bezirk: "W-Elberfeld",
      Anzahl: 22,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Döppersberg",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "22 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370214.507751075, 5679814.12204372],
    },
    text: 2127,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2040,
      Standort: "Paul-Humburg-Straße - Heubruch",
      Bezirk: "W-Barmen",
      Anzahl: 12,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Paul-Humburg-Straße - Heubruch",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "12 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374343.547058929, 5681654.57445966],
    },
    text: 2040,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2036,
      Standort: "Große Flurstraße neben 38",
      Bezirk: "W-Barmen",
      Anzahl: 18,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Große Flurstraße neben 38",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "18 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374575.905387897, 5681768.42305967],
    },
    text: 2036,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2131,
      Standort: "Auer Schulstraße - Bergische VHS",
      Bezirk: "W-Elberfeld",
      Anzahl: 31,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: null,
      info: {
        title: "Auer Schulstraße - Bergische VHS",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "31 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370189.35565945, 5679862.31414219],
    },
    text: 2131,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2054,
      Standort: "Heubruch - Parkhaus",
      Bezirk: "W-Barmen",
      Anzahl: 8,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Heubruch - Parkhaus",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "8 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374356.311885279, 5681676.66456211],
    },
    text: 2054,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2119,
      Standort: "Immermannstraße - Rampe",
      Bezirk: "W-Elberfeld",
      Anzahl: 35,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: null,
      info: {
        title: "Immermannstraße - Rampe",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "35 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370599.78329532, 5679781.23392786],
    },
    text: 2119,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2127,
      Standort: "Döppersberg",
      Bezirk: "W-Elberfeld",
      Anzahl: 6,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Döppersberg",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "6 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [371106.513171566, 5679851.2927943],
    },
    text: 2127,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2104,
      Standort: "Bankstraße - Ecke Mäuerchen",
      Bezirk: "W-Elberfeld",
      Anzahl: 14,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Bankstraße - Ecke Mäuerchen",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "14 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370507.155219089, 5679927.91053406],
    },
    text: 2104,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2137,
      Standort: "Immermannstraße - Rampe",
      Bezirk: "W-Elberfeld",
      Anzahl: 35,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: null,
      info: {
        title: "Immermannstraße - Rampe",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "35 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370547.715660629, 5679774.84431578],
    },
    text: 2137,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2027,
      Standort: "Unterdörnen - Finanzamt",
      Bezirk: "W-Barmen",
      Anzahl: 12,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Unterdörnen - Finanzamt",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "12 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [373946.189689425, 5681302.49512394],
    },
    text: 2027,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2166,
      Standort: "Johannisberg - Parkpalette 1",
      Bezirk: "W-Elberfeld",
      Anzahl: 13,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: null,
      info: {
        title: "Johannisberg - Parkpalette 1",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "13 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370495.618999999, 5679635.213],
    },
    text: 2166,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2120,
      Standort: "Aue 26",
      Bezirk: "W-Elberfeld",
      Anzahl: 10,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Aue 26",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "10 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [369995.669213356, 5679720.79756145],
    },
    text: 2120,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2007,
      Standort: "Parlamentstraße gegenüber Park",
      Bezirk: "W-Barmen",
      Anzahl: 15,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Parlamentstraße gegenüber Park",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "15 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374270.483868319, 5681665.10839712],
    },
    text: 2007,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2121,
      Standort: "Aue - Ecke Obergrünewalder",
      Bezirk: "W-Elberfeld",
      Anzahl: 12,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Aue - Ecke Obergrünewalder",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "12 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370126.191950833, 5679774.62944059],
    },
    text: 2121,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2110,
      Standort: "Südstraße - B7",
      Bezirk: "W-Elberfeld",
      Anzahl: 29,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: null,
      info: {
        title: "Südstraße - B7",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "29 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370408.085999999, 5679751.427],
    },
    text: 2110,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2122,
      Standort: "Friedrich-Ebert-Straße gegenüber 16",
      Bezirk: "W-Elberfeld",
      Anzahl: 27,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Friedrich-Ebert-Straße gegenüber 16",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "27 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370245.240401432, 5679971.1068372],
    },
    text: 2122,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2116,
      Standort: "Bundesallee 3 - Parkplatz Alsenstraße",
      Bezirk: "W-Elberfeld",
      Anzahl: 38,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: null,
      info: {
        title: "Bundesallee 3 - Parkplatz Alsenstraße",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "38 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370086.12723889, 5679702.60887612],
    },
    text: 2116,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2017,
      Standort: "Große Flurstraße - Parkhaus",
      Bezirk: "W-Barmen",
      Anzahl: 18,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Große Flurstraße - Parkhaus",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "18 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374478.863424456, 5681729.21467473],
    },
    text: 2017,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2021,
      Standort: "Winklerstraße - Schwebebahnhof",
      Bezirk: "W-Barmen",
      Anzahl: 15,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Winklerstraße - Schwebebahnhof",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "15 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374317.765890876, 5681310.82020351],
    },
    text: 2021,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2138,
      Standort: "Bundesallee 219",
      Bezirk: "W-Elberfeld",
      Anzahl: 8,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: null,
      info: {
        title: "Bundesallee 219",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "8 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [371089.631000001, 5679957.358],
    },
    text: 2138,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2156,
      Standort: "Robertstr 1",
      Bezirk: "W-Elberfeld",
      Anzahl: 6,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Robertstr 1",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "6 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370796.164398974, 5680343.62713106],
    },
    text: 2156,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2143,
      Standort: "Schauspielhaus",
      Bezirk: "W-Elberfeld",
      Anzahl: 70,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Schauspielhaus",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "70 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [371409.682, 5679843.303],
    },
    text: 2143,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2025,
      Standort: "Höhne - Rudolf-Herzog-Straße 7",
      Bezirk: "W-Barmen",
      Anzahl: 18,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Höhne - Rudolf-Herzog-Straße 7",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "18 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374794.217104746, 5681570.27887288],
    },
    text: 2025,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2112,
      Standort: "Zollstr gegenüber 11",
      Bezirk: "W-Elberfeld",
      Anzahl: 5,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Zollstr gegenüber 11",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "5 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [371056.713439515, 5680119.43659961],
    },
    text: 2112,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2026,
      Standort: "Bahnhof Barmen WEST",
      Bezirk: "W-Barmen",
      Anzahl: 57,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: "2,00 €",
      info: {
        title: "Bahnhof Barmen WEST",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "57 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374152.07236364, 5681139.86181018],
    },
    text: 2026,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2019,
      Standort: "Wegnerstraße - Ecke Kleine Flurstraße",
      Bezirk: "W-Barmen",
      Anzahl: 7,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Wegnerstraße - Ecke Kleine Flurstraße",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "7 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374605.08144905, 5681651.99875359],
    },
    text: 2019,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2048,
      Standort: "Emil-Ritterhaus-Straße",
      Bezirk: "W-Barmen",
      Anzahl: 7,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Emil-Ritterhaus-Straße",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "7 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374653.545934845, 5681739.41223289],
    },
    text: 2048,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2132,
      Standort: "Kipdorf - Parkplatz",
      Bezirk: "W-Elberfeld",
      Anzahl: 18,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Kipdorf - Parkplatz",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "18 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [371041.870527365, 5680207.8312238],
    },
    text: 2132,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2109,
      Standort: "Südstraße 19",
      Bezirk: "W-Elberfeld",
      Anzahl: 34,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: null,
      info: {
        title: "Südstraße 19",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "34 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370300.522633903, 5679710.91349024],
    },
    text: 2109,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2060,
      Standort: "Höhne 33",
      Bezirk: "W-Barmen",
      Anzahl: 5,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Höhne 33",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "5 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374470.799680019, 5681439.7180036],
    },
    text: 2060,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2016,
      Standort: "St.-Etienne-Ufer - Parkplatz B7",
      Bezirk: "W-Barmen",
      Anzahl: 30,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "St.-Etienne-Ufer - Parkplatz B7",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "30 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374481.634009952, 5681400.57234136],
    },
    text: 2016,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2003,
      Standort: "St.-Etienne-Ufer - Parkplatz B7",
      Bezirk: "W-Barmen",
      Anzahl: 30,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "St.-Etienne-Ufer - Parkplatz B7",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "30 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374517.890139478, 5681422.16498099],
    },
    text: 2003,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2068,
      Standort: "Wegnerstraße - Brauhaus",
      Bezirk: "W-Barmen",
      Anzahl: 44,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Wegnerstraße - Brauhaus",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "44 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374564.74828505, 5681660.47469763],
    },
    text: 2068,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2139,
      Standort: "Bundesallee 4 - Alsenstraße",
      Bezirk: "W-Elberfeld",
      Anzahl: 47,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: null,
      info: {
        title: "Bundesallee 4 - Alsenstraße",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "47 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370048.004507698, 5679703.19986167],
    },
    text: 2139,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2136,
      Standort: "Kolpingstraße",
      Bezirk: "W-Elberfeld",
      Anzahl: 4,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Kolpingstraße",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "4 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370276.937384419, 5680071.86842256],
    },
    text: 2136,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2006,
      Standort: "Paul-Humburg-Straße - Gemarker Ufer",
      Bezirk: "W-Barmen",
      Anzahl: 6,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Paul-Humburg-Straße - Gemarker Ufer",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "6 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374276.069167066, 5681602.61972089],
    },
    text: 2006,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2008,
      Standort: "Heubruch - EDV",
      Bezirk: "W-Barmen",
      Anzahl: 16,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Heubruch - EDV",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "16 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374380.077028109, 5681618.02618948],
    },
    text: 2008,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2030,
      Standort: "Bleicherstraße - Schule",
      Bezirk: "W-Barmen",
      Anzahl: 30,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Bleicherstraße - Schule",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "30 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374068.058846531, 5681502.27898097],
    },
    text: 2030,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2130,
      Standort: "Luisenstraße gegenüber 108",
      Bezirk: "W-Elberfeld",
      Anzahl: 13,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Luisenstraße gegenüber 108",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "13 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370001.295004912, 5679978.75805863],
    },
    text: 2130,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2033,
      Standort: "Wittensteinstraße 327",
      Bezirk: "W-Barmen",
      Anzahl: 15,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: "2,00 €",
      info: {
        title: "Wittensteinstraße 327",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "15 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [373965.236777815, 5681068.93271954],
    },
    text: 2033,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2117,
      Standort: "Döppersberg Nord",
      Bezirk: "W-Elberfeld",
      Anzahl: 8,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Döppersberg Nord",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "8 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370899.916000001, 5679838.746],
    },
    text: 2117,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2105,
      Standort: "Kasinostr - Ecke Am Heckweiher",
      Bezirk: "W-Elberfeld",
      Anzahl: 4,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Kasinostr - Ecke Am Heckweiher",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "4 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370306.381708168, 5680094.1610544],
    },
    text: 2105,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2004,
      Standort: "Rolingswerth - Parkplatz B7",
      Bezirk: "W-Barmen",
      Anzahl: 19,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Rolingswerth - Parkplatz B7",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "19 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374456.503085046, 5681371.12107066],
    },
    text: 2004,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2108,
      Standort: "Am Kolk - Post",
      Bezirk: "W-Elberfeld",
      Anzahl: 51,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Am Kolk - Post",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "51 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370851.798821155, 5680139.44937805],
    },
    text: 2108,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2037,
      Standort: "Große Flurstraße gegenüber 38",
      Bezirk: "W-Barmen",
      Anzahl: 16,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Große Flurstraße gegenüber 38",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "16 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374580.663123889, 5681785.05826289],
    },
    text: 2037,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2046,
      Standort: "Bernhard-Letterhaus-Straße (Wupper)",
      Bezirk: "W-Barmen",
      Anzahl: 25,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Bernhard-Letterhaus-Straße (Wupper)",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "25 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374134.081229445, 5681373.48169542],
    },
    text: 2046,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2015,
      Standort: "Mühlenweg gegenüber 3",
      Bezirk: "W-Barmen",
      Anzahl: 22,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Mühlenweg gegenüber 3",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "22 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374348.304605697, 5681726.21673011],
    },
    text: 2015,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2123,
      Standort: "Friedrich-Ebert-Straße 33",
      Bezirk: "W-Elberfeld",
      Anzahl: 34,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Friedrich-Ebert-Straße 33",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "34 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370077.669385321, 5679886.11645331],
    },
    text: 2123,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2160,
      Standort: "Luisenstraße 30",
      Bezirk: "W-Elberfeld",
      Anzahl: 38,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Luisenstraße 30",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "38 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370357.015893636, 5680161.46005447],
    },
    text: 2160,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2118,
      Standort: "Bundesallee 247",
      Bezirk: "W-Elberfeld",
      Anzahl: 5,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: null,
      info: {
        title: "Bundesallee 247",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "5 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [371320.028999999, 5679950.218],
    },
    text: 2118,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2161,
      Standort: "Hofkamp 17",
      Bezirk: "W-Elberfeld",
      Anzahl: 6,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Hofkamp 17",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "6 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370866.851752934, 5680268.68627286],
    },
    text: 2161,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2162,
      Standort: "Hofkamp 53",
      Bezirk: "W-Elberfeld",
      Anzahl: 4,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Hofkamp 53",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "4 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [371070.682794973, 5680240.79498859],
    },
    text: 2162,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2129,
      Standort: "Laurentiusstraße 30",
      Bezirk: "W-Elberfeld",
      Anzahl: 11,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Laurentiusstraße 30",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "11 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370289.826089564, 5679862.58908891],
    },
    text: 2129,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2022,
      Standort: "Opernhaus - Parkplatz Ost",
      Bezirk: "W-Barmen",
      Anzahl: 105,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: "3,00 €",
      Abendtarif: "2,00 €",
      info: {
        title: "Opernhaus - Parkplatz Ost",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "105 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [373880.978062423, 5681067.53906814],
    },
    text: 2022,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2044,
      Standort: "Wegnerstraße - Ost",
      Bezirk: "W-Barmen",
      Anzahl: 7,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Wegnerstraße - Ost",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "7 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374678.523314683, 5681671.84386619],
    },
    text: 2044,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2153,
      Standort: "Wesendonkstr B7",
      Bezirk: "W-Elberfeld",
      Anzahl: 6,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Wesendonkstr B7",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "6 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [371036.29770771, 5679964.26797589],
    },
    text: 2153,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2047,
      Standort: "Beckmannshof 12",
      Bezirk: "W-Barmen",
      Anzahl: 10,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Beckmannshof 12",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "10 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374673.821602566, 5681760.4536504],
    },
    text: 2047,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2126,
      Standort: "Luisenstraße 94",
      Bezirk: "W-Elberfeld",
      Anzahl: 5,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Luisenstraße 94",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "5 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370079.383000001, 5680018.22],
    },
    text: 2126,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2103,
      Standort: "Friedrich-Ebert-Straße 10",
      Bezirk: "W-Elberfeld",
      Anzahl: 21,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Friedrich-Ebert-Straße 10",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "21 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [370272.188488311, 5679997.94622422],
    },
    text: 2103,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2014,
      Standort: "Mühlenweg 37",
      Bezirk: "W-Barmen",
      Anzahl: 5,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Mühlenweg 37",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "5 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374546.341305246, 5681801.65913637],
    },
    text: 2014,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2009,
      Standort: "Beckmannshof  - Kleiner Werth",
      Bezirk: "W-Barmen",
      Anzahl: 15,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Beckmannshof  - Kleiner Werth",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "15 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374746.208803857, 5681685.10474144],
    },
    text: 2009,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2001,
      Standort: "Bachstraße 26",
      Bezirk: "W-Barmen",
      Anzahl: 8,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 20 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Bachstraße 26",
        subtitle: "0,50 € je 20 Minuten",
        additionalInfo: "8 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [374773.930660741, 5681822.05915629],
    },
    text: 2001,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2125,
      Standort: "Friedrich-Ebert-Straße 88",
      Bezirk: "W-Elberfeld",
      Anzahl: 13,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Friedrich-Ebert-Straße 88",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "13 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [369802.779199098, 5679720.75787386],
    },
    text: 2125,
  },
  {
    type: "Feature",
    properties: {
      Nummer: 2135,
      Standort: "Friedrich-Ebert-Straße 81",
      Bezirk: "W-Elberfeld",
      Anzahl: 17,
      Dauer_Ges: "keine Festlegung getroffen",
      Gebuehr: "0,50 € je 30 Minuten",
      Tagtarif: null,
      Abendtarif: null,
      info: {
        title: "Friedrich-Ebert-Straße 81",
        subtitle: "0,50 € je 30 Minuten",
        additionalInfo: "17 Plätze",
      },
    },
    geometry: {
      type: "Point",
      coordinates: [369838.799646139, 5679734.23709874],
    },
    text: 2135,
  },
];
export default x;
